import type { ReactNode } from 'react';
import { I18nProvider } from '@react-aria/i18n';
import { useTranslation } from '@rhino-project/core/i18n';

/** Share Rhino's selected language with HeroUI's React Aria components. */
export const LocaleProvider = ({ children }: { children: ReactNode }) => {
  const { locale } = useTranslation();
  return (
    <I18nProvider locale={locale.replaceAll('_', '-')}>{children}</I18nProvider>
  );
};
